import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { PrintNotifier } from './print-notifier';
import { PrintState } from './print-state';

@Injectable()
export class PrintProvider extends BaseProvider<PrintNotifier, PrintState> {
  constructor() {
    super(PrintNotifier);
  }
}
